import React, { useState, useEffect, useContext } from "react";
import MUIDataTable from "mui-datatables";
import { formatDateTime, isoToSqlDate } from "../../../helpers/helpers";
import peij from "../../../services/peij";
import ijws from "../../../services/ijws";
import { CircularProgress, IconButton } from "@mui/material";
import Form from "../../../components/form";
import AppContext from "../../../container/context";

const PreCadastros = ({ match, history }) => {
  const { notification } = useContext(AppContext);
  const dataAtual = new Date();
  const dataAnterior = new Date();
  dataAnterior.setDate(dataAnterior.getDate() - 7);

  const [carregando, setCarregando] = useState(false);
  const [registros, setRegistros] = useState([]);
  const [linkTxt, setLinkTxt] = useState("");
  const [registroSelecionado, setRegistroSelecionado] = useState({});
  const [filtros, setFiltros] = useState({
    dataInicio: isoToSqlDate(dataAnterior.toISOString()),
    dataFim: isoToSqlDate(dataAtual.toISOString()),
    cadastrados: false,
    assinantes: false,
  });
  const [totais, setTotais] = useState({
    preCadastros: "",
    cadastros: "",
    assinaturas: "",
    percCadastros: "",
    percAssinaturas: "",
  });

  useEffect(() => {
    // carregarRelatorio();
  }, []);

  const carregarRelatorio = (filtrosEnviar = filtros) => {
    setCarregando(true);
    setRegistroSelecionado({});
    setFiltros(filtrosEnviar);

    ijws
      .get("admin/relatorios/pre-cadastros", filtrosEnviar)
      .then((registros) => {
        console.log("🚀 ~ .then ~ registros:", registros);
        const preCadastros = registros.length;
        const cadastros = registros.filter((r) => r.usuarioCadastro).length;
        const assinaturas = registros.filter(
          (r) => r.usuarioAssinaturaCriacao
        ).length;

        const totais = {
          preCadastros,
          cadastros,
          assinaturas,
          percCadastros: ((cadastros / preCadastros) * 100).toFixed(0),
          percAssinaturas: ((assinaturas / preCadastros) * 100).toFixed(0),
        };

        const linhasTxt = [];

        registros.forEach((r) => {
          r.preCadastroDataHora = formatDateTime(
            r.preCadastroDataHora,
            "D/M/Y h:m"
          );
          r.usuarioCadastro = r.usuarioCadastro
            ? formatDateTime(r.usuarioCadastro, "D/M/Y h:m")
            : "-";

          r.email = (
            <div>
              {r.preCadastroEmail}
              <br />
              {r.preCadastroEnvioEmail &&
                `(contato em ${formatDateTime(
                  r.preCadastroEnvioEmail,
                  "D/M/Y h:m"
                )})`}
            </div>
          );

          r.telefone = (
            <div>
              {r.preCadastroTelefone}
              <br />
              {r.preCadastroLigacao &&
                `(contato em ${formatDateTime(
                  r.preCadastroLigacao,
                  "D/M/Y h:m"
                )})`}
            </div>
          );

          r.contato = (
            <IconButton
              key={"key"}
              className="text-warning"
              aria-label="Delete"
              onClick={() => {
                setRegistroSelecionado(r);
                window.scrollTo({
                  top: document.documentElement.scrollHeight,
                  behavior: "smooth",
                });
              }}
            >
              <i className={"zmdi zmdi-comments"}></i>
            </IconButton>
          );

          if (r.usuarioAssinaturaCriacao) {
            r.usuarioAssinaturaCriacao = formatDateTime(
              r.usuarioAssinaturaCriacao,
              "D/M/Y h:m"
            );
          } else {
            r.usuarioAssinaturaCriacao = r.solicitacaoBoletoTransferencia
              ? `(Solicitação boleto/transferência ${formatDateTime(
                  r.solicitacaoBoletoTransferencia,
                  "D/M/Y h:m"
                )})`
              : "-";
          }

          linhasTxt.push(`${r.preCadastroNome};${r.preCadastroEmail}\n`);
        });

        setRegistros(registros);
        setCarregando(false);
        if (!registros.length) {
          setTotais({
            preCadastros: "0",
            cadastros: "0",
            assinaturas: "0",
            percCadastros: "0",
            percAssinaturas: "0",
          });
        } else {
          setTotais(totais);
        }
        gerarTxt(linhasTxt);
      });
  };

  const gerarTxt = (linhasTxt) => {
    const data = new Blob(linhasTxt, { type: "text/plain" });

    if (linkTxt !== "") window.URL.revokeObjectURL(linkTxt);

    setLinkTxt(window.URL.createObjectURL(data));
  };

  const salvarContato = (formulario) => {
    const registroSalvar = formulario;
    registroSalvar.preCadastroId = registroSelecionado.preCadastroId;

    peij
      .post("pre-cadastros/inserirContato", registroSalvar)
      .then((res) => {
        if (res.includes(200)) {
          notification("success", "Dados salvos!");
          carregarRelatorio();
        } else {
          notification(
            "error",
            "Não foi possível salvar os dados. Verifique as informações e tente novamente."
          );
        }
      })
      .catch((err) => {
        console.log(err);
        notification(
          "error",
          "Não foi possível salvar os dados. Verifique as informações e tente novamente."
        );
      });
  };

  // const definirSituacaoRegistro = (registro, dataAtual) => {
  //   if (!registro.inicio) {
  //     if (new Date(registro.previsaoInicio) < dataAtual) return "Atrasado";
  //     return "Não iniciado";
  //   }

  //   if (!registro.termino) return "Em andamento";
  //   return "Finalizado";
  // };

  const getFiltros = (filtros) => {
    return {
      dataInicio: {
        label: "Pré-cadastrado a partir de ",
        type: "date",
        space: 4,
        value: filtros.dataInicio,
      },
      dataFim: {
        label: "Pré-cadastrado até",
        type: "date",
        space: 4,
        value: filtros.dataFim,
      },
      cadastrados: {
        label: "Apenas cadastrados",
        type: "check",
        value: filtros.cadastrados,
        space: 2,
      },
      assinantes: {
        label: "Apenas assinantes",
        type: "check",
        value: filtros.assinantes,
        space: 2,
      },
    };
  };

  const formTotais = (totais) => {
    return {
      preCadastros: {
        label: "Pré-cadastros",
        type: "text",
        space: 4,
        value: totais.preCadastros,
        readOnly: true,
      },
      cadastros: {
        label: "Cadastros",
        type: "text",
        space: 4,
        value: `${totais.cadastros} (${totais.percCadastros} %)`,
        readOnly: true,
      },
      assinaturas: {
        label: "Assinaturas",
        type: "text",
        space: 4,
        value: `${totais.assinaturas} (${totais.percAssinaturas} %)`,
        readOnly: true,
      },
    };
  };

  const formRegistroSelecionado = (registroSelecionado) => {
    return {
      preCadastroNome: {
        label: "Nome",
        type: "text",
        value: registroSelecionado.preCadastroNome,
        readOnly: true,
      },
      preCadastroEmail: {
        label: "Email",
        type: "text",
        value: registroSelecionado.preCadastroEmail,
        readOnly: true,
        space: 6,
      },
      envioEmail: registroSelecionado.preCadastroEnvioEmail
        ? {
            label: "Email enviado",
            type: "text",
            value: registroSelecionado.preCadastroEnvioEmail,
            readOnly: true,
            space: 6,
          }
        : {
            label: "Registrar envio email",
            type: "check",
            space: 6,
          },
      preCadastroTelefone: {
        label: "Telefone",
        type: "text",
        value: registroSelecionado.preCadastroTelefone,
        readOnly: true,
        space: 6,
      },
      ligacao: registroSelecionado.preCadastroLigacao
        ? {
            label: "Ligação realizada",
            type: "text",
            value: registroSelecionado.preCadastroLigacao,
            readOnly: true,
            space: 6,
          }
        : {
            label: "Registrar ligação",
            type: "check",
            space: 6,
          },
      usuarioCadastro: {
        label: "Cadastro",
        type: "text",
        value: registroSelecionado.usuarioCadastro,
        readOnly: true,
        space: 6,
      },
      usuarioAssinaturaCriacao: {
        label: "Assinatura",
        type: "text",
        value: registroSelecionado.usuarioAssinaturaCriacao,
        readOnly: true,
        space: 6,
      },
      anotacoes: {
        label: "Anotações",
        type: "textarea",
        value: registroSelecionado.preCadastroAnotacoes,
      },
    };
  };

  const columns = [
    {
      name: "contato",
      label: "Contato",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "preCadastroNome",
      label: "Nome",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "preCadastroDataHora",
      label: "Pré-cadastro",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "email",
      label: "Email",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "telefone",
      label: "Telefone",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "usuarioCadastro",
      label: "Cadastro",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "usuarioAssinaturaCriacao",
      label: "Assinatura",
      options: {
        filter: false,
        sort: false,
      },
    },
  ];

  const options = {
    filter: false,
    selectableRows: false,
    download: false,
    print: false,
    viewColumns: false,
    rowsPerPage: 10,
    responsive: "scrollMaxHeight",
    textLabels: {
      body: {
        noMatch: "Nenhum registro encontrado",
      },
      pagination: {
        rowsPerPage: "Linhas por página",
      },
    },
  };

  const fContato = {
    title: "Contato",
    form: formRegistroSelecionado(registroSelecionado),
    submit: {
      label: "Salvar",
      action: salvarContato,
    },
  };

  const fFiltros = {
    title: "Filtros",
    form: getFiltros(filtros),
    submit: {
      label: "Filtrar",
      action: carregarRelatorio,
    },
  };

  const fTotais = {
    title: "Totais",
    form: formTotais(totais),
    // submit: {
    //   label: "Filtrar",
    //   action: carregarRelatorio,
    // },
  };

  return (
    <div className="pre-cadastros">
      <Form formData={fFiltros} />

      {carregando ? (
        <CircularProgress />
      ) : (
        <>
          <Form formData={fTotais} />
          <MUIDataTable
            title={"Pré-Cadastros"}
            data={registros}
            columns={columns}
            options={options}
          />
          <a
            className="btn-primary text-white"
            href={linkTxt}
            download="registros.txt"
          >
            Baixar registros
          </a>

          {/* <Form formData={fContato} /> */}
        </>
      )}
    </div>
  );
};

export default PreCadastros;
